import React, { createContext } from 'react';
import { DDMAttributes } from 'src/integration/ddm/providers/DDMAttributesProvider';
import { IViewCaseResponse } from 'src/state/slice/models/CaseLifecycleTypes';

const initialState: CaseDetailsType = {
  caseId: '',
};

export type CaseDetailsType = {
  caseId: string;
  caseDetailsResponse?: IViewCaseResponse;
  ddmAttributes?: DDMAttributes;
};

export const CaseDetailsContext = createContext<CaseDetailsType>(initialState);

const CaseDetailsProvider = ({
  children,
  caseId,
  caseDetailsResponse,
  ddmAttributes,
}) => {
  return (
    <CaseDetailsContext.Provider
      value={{ caseId, caseDetailsResponse, ddmAttributes }}
    >
      {children}
    </CaseDetailsContext.Provider>
  );
};

export default CaseDetailsProvider;
